import { readPublicEnv } from "./public";

export const env = readPublicEnv({
  VITE_API_URL: import.meta.env.VITE_API_URL,
  VITE_API_URL_AU: import.meta.env.VITE_API_URL_AU,
  VITE_API_URL_US: import.meta.env.VITE_API_URL_US,
  VITE_AUTH_URL: import.meta.env.VITE_AUTH_URL,
  VITE_CHAT_API: import.meta.env.VITE_CHAT_API,
});
